import React, { useEffect, useState } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../../customHook/getCssStyle';
import { useDispatch, useSelector } from 'react-redux';
import CustomPressable from '../../../components/customPressable/customPressable';
import CustomDropDown from '../../../components/customDropdown/customDropdown';
import { getCleanUrl } from '../../../utils/Helper';
import { ImageComp } from '../../../components/Image/Image';
import { useTranslation } from 'react-i18next';
import { CHEVRON_RIGHT } from '../../../assets';
import Loader from '../../../components/Loader/loader';


const TVChannels_Potrait = (props) => {
    const { clickChannel, channelObj, updateChannelObj, getTimeSlots=()=>{}, handleRefreshChannelList } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();


    const { currentWidget } = useSelector((state) => state.deviceConfigSlice);
    const { isChannelDataLoading } = useSelector(state => state.tvRemoteSlice);


    useEffect(()=> {
        const timeInterval = setInterval(() => {
            const newTime = new Date();
            updateChannelObj({ currentTime: newTime }); 
        }, 60000)

        
        return () => {
            clearInterval(timeInterval)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    return (
        <>
            <View style={getStyles(["tvChannelsMainContainer"])} id='tvChannelsMainContainer'>
                {!isChannelDataLoading && <>
                    {!channelObj?.gettingChannelList ? 
                            <>
                                {channelObj?.channelList?.length > 0 && <><View style={getStyles(["tvChannelsFilterContainer"])} id='tvChannelsFilterContainer'>
                                    <View style={getStyles(["tvChannelsFilterItemContainer"])} id='tvChannelsFilterItemContainer'>
                                        <CustomDropDown
                                            placeholder={t('tv_remote.select_language')}
                                            selectedOption={channelObj.selectedCategory}
                                            options={["All categories", ...channelObj?.categoryList]?.map(item => {
                                                return {
                                                    value: item,
                                                    label: item
                                                }
                                                })}
                                            onSelectOption={(item) => updateChannelObj({selectedCategory: item.value})}
                                        />
                                    </View>
                                    <View style={getStyles(["tvChannelsFilterItemContainer"])} id='tvChannelsFilterItemContainer'>
                                        <CustomDropDown
                                            placeholder={t('tv_remote.select_language')}
                                            selectedOption={channelObj.selectedLanguage}
                                            options={["All languages", ...channelObj?.languageList]?.map(item => {
                                                return {
                                                    value: item,
                                                    label: item
                                                }
                                                })}
                                            onSelectOption={(item) => updateChannelObj({selectedLanguage: item.value})}
                                        />
                                    </View>
                                </View> 
                            

                            <View style={getStyles(["tvChannelsListContainer"])} id='tvChannelsListContainer'>
                                {currentWidget?.widgetType === "EPG" && <View style={getStyles(["tvChannelsSlotContainer"])} id="tvChannelsSlotContainer">
                                    {getTimeSlots()}
                                </View>}

                                <View style={getStyles([currentWidget?.widgetType === "EPG" ? { width: channelObj?.width } : {}, ""])}>
                                    {
                                        channelObj?.channelList?.map((itrator) => {
                                            const currentTime = channelObj?.currentTime; 

                                            // Find the current program in the schedules
                                            const currentProgram = itrator.schedules.find((program) => {
                                                const startTime = new Date(program.startTime);
                                                const endTime = new Date(program.endTime);
                                                return currentTime >= startTime && currentTime <= endTime;
                                            });

                                                // Calculate progress percentage for the current program
                                            let progressPercentage = 0;
                                            if (currentProgram) {
                                                const startTime = new Date(currentProgram.startTime);
                                                const endTime = new Date(currentProgram.endTime);
                                                progressPercentage = ((currentTime - startTime) / (endTime - startTime)) * 100;
                                                progressPercentage = Math.min(progressPercentage, 100); 
                                                }

                                            return (
                                                <CustomPressable onPress={() => clickChannel(itrator)} style={getStyles(["list_itemContainer"])} id="list_itemContainer">

                                                        {/* Progress Bar Overlay */}
                                                        {/* {currentProgram && (<div className="progress-overlay" style={{ width: `${progressPercentage}%`}}></div>)} */}
                                                    {
                                                        currentWidget?.widgetType === "EPG" ? 
                                                            itrator.schedules.length > 0 ?
                                                                itrator.schedules.map((itr) => {
                                                                    return (
                                                                        <View style={getStyles([itr.duration > 59 ? "time-full-hour" : "time-half-hour"])}>
                                                                            <Text style={getStyles([""])}>{itr.title}</Text>
                                                                            <Text style={getStyles([""])}>{itr.descLong}</Text>
                                                                        </View>
                                                                    )
                                                                }) :
                                                                <View style={getStyles([""])}>
                                                                    <Text style={getStyles([""])}>{itrator.channelName}</Text>
                                                                    <Text style={getStyles([""])}></Text>
                                                                </View>

                                                        : 
                                                        <>
                                                            <View style={getStyles(['list_itemContainer_image'])} id='list_itemContainer_image'>
                                                                <ImageComp
                                                                    source={getCleanUrl(itrator?.iconUrl)}
                                                                    style={getStyles(["list_itemContainer_image_img", { width: "100%", height: "100%" }])}
                                                                    id='list_itemContainer_image_img'
                                                                />
                                                            </View>
                                                            
                                                            <View style={getStyles(["list_itemContainer_textContainer"])}>
                                                                <Text style={getStyles(["list_itemContainer_textContainer_title"])}>{itrator.channelName}</Text>

                                                                {currentProgram ? ( 
                                                                        <Text style={getStyles(["list_itemContainer_textContainer_subtitle"])}>{currentProgram.title}</Text>
                                                                ) : (
                                                                        <Text style={getStyles(["list_itemContainer_textContainer_subtitle"])}>No current program</Text>
                                                                )}
                                                            </View>

                                                            <View style={getStyles(['list_itemContainer_arrow'])}>
                                                                <ImageComp source={CHEVRON_RIGHT} style={getStyles(['list_itemContainer_arrow_img'])} />
                                                            </View>
                                                        </>

                                                    }
                                                </CustomPressable>
                                            )
                                        })
                                    }
                                </View>
                            </View></>}
                            </>
                        : null
                    }
                                
                </>}
                {!channelObj?.channelList?.length && !isChannelDataLoading &&
                    <CustomPressable style={getStyles(['primaryBtn'])} id="primaryBtn" onPress={() => handleRefreshChannelList()}>
                        <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>
                            {t("room_control.tv_control.channel_not_available")}
                        </Text>
                    </CustomPressable>}
                    
                    {isChannelDataLoading && <View style={getStyles(['mediaDeviceListContainer_loader'])}>
                        <Loader size={'small'} style={getStyles(['mediaDeviceList_loader'])} />
                    </View>}
            </View>
        </>
    )
}

export default TVChannels_Potrait
